class GlobalConstants {
    static PDF_WINDOW_TARGET_NAME = "_subtrux_pdf";
    static DOC_TARGET_NAME = "_doc";
    static MAP_SHARE_VIC_TARGET_NAME = "_mapshare_vic";
}
export default GlobalConstants;
